const scripts = new Map<string, Promise<void>>();

export const loadCaptchaScript = (source: string): Promise<void> => {
  const existing = scripts.get(source);
  if (existing) return existing;
  const script = document.createElement("script");
  script.src = source;
  script.async = true;
  const promise = new Promise<void>((resolve, reject) => {
    const fail = () => {
      window.clearTimeout(timeout);
      scripts.delete(source);
      script.remove();
      reject(new Error("Unable to load captcha"));
    };
    const timeout = window.setTimeout(fail, 20000);
    script.onload = () => {
      window.clearTimeout(timeout);
      resolve();
    };
    script.onerror = fail;
    document.head.appendChild(script);
  });
  scripts.set(source, promise);
  return promise;
};
